//import { load_locations } from '../main'; --this creates bug because it imports the whole main.js

function load_locations() {
    $.ajax({
        url: $('#search-locations').attr('data-ajax-url'),
        type: 'post',
        success: function (data)
        {
            $('#search-locations').html(data).selectpicker('refresh');
            //location_loaded = true;
        },
        error: function(jqXHR) {
            console.log(jqXHR.statusText)
        }
    });
}

$('.property-list-toggle').click(function(){
    $.ajax
    ({ 
        url: $(this).attr('data-ajax-url'),
        type: 'post',
        dataType:"json",
        success: function($json)
        {
            var toggle = $("#property-list-toggle-"+$json['property']);
            if($json["status"] === "active") {
                toggle.find("i").attr("class","fa fa-toggle-on");
            } else {
                toggle.find("i").attr("class","fa fa-toggle-off");
            }
        },
        error: function(jqXHR) {
            console.log(jqXHR.statusText);
        }
    });
});

$('#properties .panel-heading .toggle-btn').on('click', function(e) {
    e.preventDefault();
    $('#properties .search-widget').slideToggle(300);
    if($(this).find("i").hasClass("fa-plus")) {
        $(this).find("i").attr("class","fa fa-minus");
    } else {
        $(this).find("i").attr("class","fa fa-plus");
    }
});

function refreshPropList() {
    if($(window).width() > 700) {
        $('#list-type').removeClass('proerty-th');
        $('#list-type').addClass('proerty-th-list');
        $('#list-type .module').show();
    } else {
        $('#list-type').removeClass('proerty-th-list');
        $('#list-type').addClass('proerty-th');
        $('#list-type .module').hide();
    }
}

$(document).ready(function () {

    refreshPropList();
    
    if( $('#search-locations').has('option').length === 0 ) {
        load_locations();
    }
    
    $(window).resize(function () {
        refreshPropList();
    });
    
});

document.addEventListener("DOMContentLoaded", function() {
  var lazyImages = [].slice.call(document.querySelectorAll(".lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          loadImage(lazyImage);
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    Array.from(lazyImages).forEach(image => loadImage(image));
  }
});

function loadImage(image) {
    //console.log("load image "+image.dataset.ref);
    image.classList.add("lazy-loaded");
    image.src = image.dataset.src;
}

//$(".item-thumb img").on('load', function() { console.log("img on load "+$(this).attr("class")+" "+$(this).data("ref")); })
    
$(".lazy").on('load', function() { 
    if($(this).hasClass("lazy-loaded")) {
        $(this).removeClass("lazy-loading");
    }
});

$('.sort-by-list a').click(function(event){
    if($( ".sort-by-list" ).data("form")) {
        event.preventDefault();
        event.stopPropagation();
        $( "form" ).prepend("<input type=\"hidden\" name=\"form[sortBy]\" value="+$(this).attr('id')+">");
        $( "form" ).prepend("<input type=\"hidden\" name=\"form[sortDirection]\" value="+$(this).attr('class')+">");
        $( "form" ).submit();
    }
});

$('.pagination a').click(function(event){
    if($( ".sort-by-list" ).data("form")) {
        event.preventDefault();
        event.stopPropagation();
        
        if($( ".sort-by-list .active" )) {
            var item = $( ".sort-by-list .active a" );
            $( "form" ).prepend("<input type=\"hidden\" name=\"form[sortBy]\" value="+item.attr('id')+">");
            var direction = "asc";
            if(item.attr('class')==="asc") {
                direction = "desc";
            }
            $( "form" ).prepend("<input type=\"hidden\" name=\"form[sortDirection]\" value="+direction+">");
        }
        
        $( "form" ).prepend("<input type=\"hidden\" name=\"form[pageTarget]\" value="+$.urlParam($(this).attr('href'),'page')+">");
        $( "form" ).submit();
    }
});

$.urlParam = function (url, name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                      .exec(url);

    return (results !== null) ? results[1] || 0 : false;
}
